import React from 'react';
import { Star, Quote } from 'lucide-react';

const NewTestimonials = () => {
  const testimonials = [
    {
      quote: "We were losing over $2,000 a month in processing fees without realizing it. Davway's terminals eliminated those fees completely. Best business decision we made this year.",
      author: "Mike R.",
      company: "Auto Service Pro",
      rating: 5
    },
    {
      quote: "The reporting features alone are worth it. I can see exactly what's happening with my transactions in real-time. Plus, zero fees means more profit.",
      author: "Sarah T.",
      company: "Towing A&S",
      rating: 5
    },
    {
      quote: "Setup was incredibly easy. Terminal arrived pre-configured, plugged it in, and started processing same day. The savings add up fast.",
      author: "Sadek A.",
      company: "Kings Motel",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-20" style={{ backgroundColor: '#F8FAFC' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-6" style={{ backgroundColor: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37' }}>
            <Star size={16} fill="currentColor" />
            <span>Success Stories</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#0F172A' }}>
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600">
            Businesses that stopped losing money on processing fees
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative"
              data-testid={`testimonial-${index}`}
            >
              {/* Quote Icon */}
              <div 
                className="absolute -top-4 left-6 w-10 h-10 rounded-full flex items-center justify-center"
                style={{ backgroundColor: '#D4AF37' }}
              >
                <Quote className="text-white" size={18} />
              </div>
              
              {/* Stars */}
              <div className="flex gap-1 mb-4 pt-2">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} style={{ color: '#D4AF37' }} size={20} fill="currentColor" />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-gray-600 mb-6 text-lg leading-relaxed">
                "{testimonial.quote}"
              </p>
              
              {/* Author */}
              <div className="border-t border-gray-200 pt-4">
                <p className="font-bold" style={{ color: '#0F172A' }}>{testimonial.author}</p>
                <p className="text-gray-500 text-sm">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewTestimonials;
